import { Input, Component } from '@angular/core'
import { PostDeclineReason } from '../submissions/submission.queries'

@Component({
  selector: 'post-decline-reasons',
  templateUrl: './post-decline-reasons.component.html',
})
export class PostDeclineReasons {
  @Input() selectedPostDeclineReasons: PostDeclineReason[]
  @Input() postDeclineComments: PostDeclineReason
  declineReasons: string[]
  declineComments: string

  constructor() {}

  ngOnChanges(): void {
    this.declineReasons = this.selectedPostDeclineReasons.map((r) => r.reason)
    this.declineComments = this.postDeclineComments?.comments
    if (this.declineComments === 'No action by customer') this.declineComments = null
  }
}
